import React from 'react'
import { Menu, Text, HStack } from '@chakra-ui/react'
import { LuArrowUpDown } from 'react-icons/lu'

export default function SortBlock({ sortType, changeSortType }) {
  return (
    <Menu.Root>
      <Menu.Trigger asChild>
        <button type="button" style={{ background: 'none', border: 'none', cursor: 'pointer', outline: 'none' }}>
          <HStack gap={0} fontSize="3xs" color="label.primary" fontWeight="semibold">
            <LuArrowUpDown />
            <Text pl={1}>並び替え</Text>
          </HStack>
        </button>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content fontSize="3xs">
          <Menu.Item
            value="buy"
            onClick={() => changeSortType('buy')}
            bg={sortType === 'buy' ? 'bg.tertiary' : null}
            fontWeight={sortType === 'buy' ? 'semibold' : null}
          >
            購入順
          </Menu.Item>
          <Menu.Item
            value="title"
            onClick={() => changeSortType('title')}
            bg={sortType === 'title' ? 'bg.tertiary' : null}
            fontWeight={sortType === 'title' ? 'semibold' : null}
          >
            作品順
          </Menu.Item>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  )
}
